import { render, staticRenderFns } from "./ChooseSubscriptionButton.vue?vue&type=template&id=0a4f0fa2&scoped=true&"
import script from "./ChooseSubscriptionButton.vue?vue&type=script&lang=ts&"
export * from "./ChooseSubscriptionButton.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseSubscriptionButton.vue?vue&type=style&index=0&id=0a4f0fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f0fa2",
  null
  
)

export default component.exports